/**
 * Rota de acesso do usuário ao iSend, decidida pelo host em que o front foi aberto:
 * - INTRANET: rede interna/VPN (VUE_APP_URL) → API direta (VUE_APP_ENDPOINT*).
 * - NETSKOPE: acesso externo pelo proxy Netskope (VUE_APP_NETSKOPE_APP_URL) → API pelo proxy (VUE_APP_NETSKOPE_ENDPOINT*).
 *
 * A detecção depende só do host da página e de variável de build, então é determinística;
 * o resultado fica em memória apenas para não reparsear a URL a cada requisição.
 */
export const ACCESS_ROUTE = Object.freeze({
  INTRANET: 'intranet',
  NETSKOPE: 'netskope',
});

let memoryRoute = null;

function hostOf(url) {
  try {
    return new URL(url).host;
  } catch (error) {
    return '';
  }
}

function detectAccessRoute() {
  const location = typeof window !== 'undefined' ? window.location : null;
  const netskopeHost = hostOf(process.env.VUE_APP_NETSKOPE_APP_URL);

  if (location && netskopeHost && location.host === netskopeHost) {
    return ACCESS_ROUTE.NETSKOPE;
  }
  return ACCESS_ROUTE.INTRANET;
}

/** Rota de acesso da sessão atual, detectada pelo host da página. */
export function getAccessRoute() {
  if (!memoryRoute) {
    memoryRoute = detectAccessRoute();
  }
  return memoryRoute;
}

export function isNetskopeAccess() {
  return getAccessRoute() === ACCESS_ROUTE.NETSKOPE;
}
